import { useStyles } from 'utils/useStyles';
import { css } from '@emotion/react';
import { useEffect, useState } from 'react';

const CRUISE_MESSAGES = [
  'Sorting out the details…',
  'Working through the setup…',
  'Running through the checklist…',
  'Handling the particulars…',
  'Settling everything in…',
  'Tending to the details…',
  'Arranging the pieces…',
  'Running a few checks…',
  'Getting the basics sorted…',
  'Straightening it all out…',
  'Taking care of the preliminaries…',
  'Organizing behind the scenes…',
  'Working out the last few details…',
];

const TEXT_UPDATE_DELAY = 8000;
const INITIAL_DELAY = 5000;

const FriendlyMessages = () => {
  const styles = useStyles(getStyles);
  const [counter, setCounter] = useState(-1);

  useEffect(() => {
    let interval: ReturnType<typeof setInterval>;

    const timeout = setTimeout(() => {
      setCounter(0);
      interval = setInterval(() => {
        setCounter((counter) => counter + 1);
      }, TEXT_UPDATE_DELAY);
    }, INITIAL_DELAY);

    return () => {
      clearTimeout(timeout);
      clearInterval(interval);
    };
  }, [setCounter]);

  return (
    <div key={counter} css={styles.text}>
      {counter >= 0 && CRUISE_MESSAGES[counter % CRUISE_MESSAGES.length]}
    </div>
  );
};

const getStyles = () => ({
  text: css`
    @property --shimmer-sweep-position {
      syntax: '<percentage>';
      inherits: false;
      initial-value: 100%;
    }

    font-size: 14px;
    min-height: 14px;
    margin-top: 10px;
    text-align: center;
    opacity: 0;
    color: rgba(204, 204, 220, 0.65);
    background-image: linear-gradient(
      90deg,
      rgba(204, 204, 220, 0.65) 0%,
      rgba(204, 204, 220, 0.65) 24%,
      rgba(204, 204, 220, 0.74) 34%,
      rgba(216, 218, 228, 0.88) 42%,
      rgba(232, 234, 242, 0.96) 48%,
      rgba(232, 234, 242, 0.96) 56%,
      rgba(204, 204, 220, 0.78) 60%,
      rgba(204, 204, 220, 0.65) 64%,
      rgba(204, 204, 220, 0.65) 100%
    );
    background-size: 300% 100%;
    background-position: var(--shimmer-sweep-position) 0;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    animation:
      textFade ease-in-out 8s,
      shimmer linear 2.5s infinite;

    @keyframes textFade {
      0% {
        opacity: 0;
      }

      10% {
        opacity: 1;
      }

      80% {
        opacity: 1;
      }

      90% {
        opacity: 0;
      }

      100% {
        opacity: 0;
      }
    }

    @keyframes shimmer {
      from {
        --shimmer-sweep-position: 100%;
      }

      to {
        --shimmer-sweep-position: 0%;
      }
    }

    @media (max-width: 767px) {
      font-size: 20px;
      min-height: 20px;
    }
  `,
});

export default FriendlyMessages;
